/**
 * Sitewide glass FAQ accordion: click a bubble to expand, others close.
 */
(function () {
  function textOf(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function normalize(faq) {
    faq.classList.add('faq', 'dg-faq');
    if (faq.getAttribute('role') !== 'button' && faq.tagName !== 'BUTTON') {
      faq.setAttribute('role', 'button');
      if (!faq.hasAttribute('tabindex')) faq.setAttribute('tabindex', '0');
    }

    var q = faq.querySelector('.faq__q, .faq__q');
    if (q) {
      q.classList.add('faq__q');
      if (q.tagName === 'BUTTON' || q.tagName === 'SUMMARY') {
        var label = textOf(q);
        var div = document.createElement('div');
        div.className = 'faq__q';
        var title = document.createElement('span');
        title.textContent = label;
        var plus = document.createElement('span');
        plus.setAttribute('aria-hidden', 'true');
        plus.textContent = '+';
        div.appendChild(title);
        div.appendChild(plus);
        q.replaceWith(div);
      } else if (q.querySelectorAll('span').length < 2) {
        var plus2 = document.createElement('span');
        plus2.setAttribute('aria-hidden', 'true');
        plus2.textContent = '+';
        q.appendChild(plus2);
      }
    }

    var a = faq.querySelector('.faq__a, .faq__a');
    if (a) {
      a.classList.add('faq__a');
      var onlyDiv = a.children.length === 1 && a.firstElementChild.tagName === 'DIV';
      if (!onlyDiv) {
        var wrap = document.createElement('div');
        while (a.firstChild) wrap.appendChild(a.firstChild);
        a.appendChild(wrap);
      }
    }

    faq.setAttribute('aria-expanded', faq.classList.contains('is-open') ? 'true' : 'false');
  }

  function groupOf(faq) {
    return (
      faq.closest('.faq-list, .faq-list, [data-dg-collection-faq], [data-dg-home-faq], .dg-contact__faq-list, .dg-article__bubble--faq') ||
      faq.parentElement
    );
  }

  function toggle(faq) {
    var open = faq.classList.contains('is-open');
    var group = groupOf(faq);
    group.querySelectorAll('.dg-faq').forEach(function (item) {
      item.classList.remove('is-open');
      item.setAttribute('aria-expanded', 'false');
    });
    if (!open) {
      faq.classList.add('is-open');
      faq.setAttribute('aria-expanded', 'true');
    }
  }

  function bind(faq) {
    normalize(faq);
    if (faq.dataset.dgFaqBound === '1') return;
    faq.dataset.dgFaqBound = '1';
    faq.addEventListener('click', function (event) {
      if (event.target.closest('a')) return;
      toggle(faq);
    });
    faq.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (event.target.closest('a')) return;
      event.preventDefault();
      toggle(faq);
    });
  }

  function init() {
    document.querySelectorAll('.dg-faq, .dg-article-faq-item').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
